<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-full md:w-1/4 lg:w-3/12 mb-5 md:mb-0 lg:pr-2">
					<img :src="getUrlOfFile(vars.image, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Photo</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full md:w-3/4 lg:w-9/12 md:px-5">
					<div class="w-full mb-5 flex flex-row">
						<div class="w-3/4 pr-2">
							<vs-input 
									autocomplete="off"
									v-validate="'required'" 
									label="Name" 
									name="name" 
									type="text"
									v-model="models.name" 
									class="w-full"/>
							<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
						<div class="w-1/4">
							<vs-input 
									autocomplete="off"
									label="Promo Code" 
									type="text"
									v-model="promoCode"
									@keydown.space.prevent
									class="w-full"/>
						</div>
					</div>
					<div class="w-full mb-5">
						<label for="description">Description</label>
						<quill-editor
							v-model="models.description"
						/>
					</div>
					<div class="w-full mb-3">
						<vs-input 
								autocomplete="off"
								v-validate="'url'" 
								label="Link" 
								name="link"
								type="url"
								v-model="models.link" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('link')">{{ errors.first('link') }}</span>
					</div>
					<div class="w-full mb-5 flex flex-row">
						<div class="w-1/3">
							<label for="">Type</label>
							<select class="w-full" v-model="models.type">
								<option v-for="(type, index) in masters.types" :key="index" :value="type.value">{{type.text}}</option>
							</select>
						</div>
						<div class="w-2/3 lg:pl-2" v-if="type == 2">
							<label for="type">Event</label>
							<v-select
								class="w-full"
								placeholder="Select Event"
								:options="masters.events"
								label="name"
								:reduce="type => type.id"
								v-model="models.eventId"/>
							<input type="hidden" name="event" v-validate="vars.eventValidate" v-model="models.eventId">
							<span class="text-danger text-sm" v-show="errors.has('event')">{{ errors.first('event') }}</span>
						</div>
					</div>

					<div class="w-full mb-5">
						<label class="pl-1 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-2">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import {
		getUrlOfFile,
		uploadFile
	} from '@/utils/helpers.js';

	export default {
		name: 'FormUser',
		data() {
			return {
				getUrlOfFile,
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: "",
					description: "",
					image: "",
					isActive: true,
					link: "",
					promoCode: "",
					type: 1,
					eventId: null
				},
				masters: {
					types: [
						{
							text: 'Banner',
							value: 1
						},
						{
							text: 'Event',
							value: 2
						}
					],
					events: []
				},
				vars: {
					FormData: new FormData(),
					image: '',
					eventValidate: ''
				}
			}
		},
		computed: {
			promoCode: {
				get() {
					return this.models.promoCode
				},
				set(val) {
					this.models.promoCode = val.toUpperCase()
				}
			},
			type() {
				return this.models.type
			}
		},
		watch: {
			type() {
				this.vars.eventValidate = this.type == 2 ? 'required' : ''
			}
		},
		created() {
			this.getById();
			this.getEvents()
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.banners}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name;
							this.models.description = data.description;
							this.models.link = data.link;
							this.models.promoCode = data.promoCode
							this.models.isActive = data.isActive;
							this.vars.image = data.image;

							this.models.eventId = data.eventId
							this.models.type = data.type
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},

			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},

			getEvents() {
				this.$axios.get(api.misc_events)
					.then(res => {
						this.masters.events = res.data.data
					})
			},
			
			save() {
				this.vars.FormData = new FormData();
				this.$validator.validate().then(async valid => {
					if (valid) {
						let request = "";
						let message = "create"
						
						this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)

						for (const i in this.models) {
							this.vars.FormData.append(i, this.models[i]);
						}

						if (!this.$route.params.id) {
							request = this.$axios.post(api.banners, this.vars.FormData);
						} else {
							message = "update"
							request = this.$axios.put(`${api.banners}/${this.$route.params.id}`, this.vars.FormData);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} banners`,)
								this.$router.push({
									name: this.config.uri
								})
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>